import styled from 'styled-components';

const CommentItemBody = styled.div`
  margin-top: 4px;
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
`;

export default CommentItemBody;
